module.exports = __webpack_public_path__ + "img/border_Ring3.9e877484.svg";